import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PitchTabIntroProps {
  heading?: string;
  lead?: string;
}

/**
 * The heading and line of one Pitch tab, under the tabs ("Who fits Low Tide"). The page title is
 * "Pitch" on every tab, so the own title of a tab moves here (design navigation-v2 d 4d).
 */
const PitchTabIntroComponent: React.FC<PitchTabIntroProps> = ({ heading, lead }) => {
  if (heading === undefined && lead === undefined) {
    return null;
  }
  return (
    <div>
      {heading !== undefined && <h2 className={clsx(styles.h2, lead !== undefined && 'mb-1')}>{heading}</h2>}
      {lead !== undefined && <p className={styles.sub}>{lead}</p>}
    </div>
  );
};

export const PitchTabIntro = TypedMemo(PitchTabIntroComponent);
